// removed by extract-text-webpack-plugin
module.exports = {"paymentOptions":"d3hEogn","provider":"_2t5mfE3"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Footer/PaymentOptions/index.css
// module id = ./template/components/Footer/PaymentOptions/index.css
// module chunks = client.sitechrome